'use client';

import { useAuth } from '@/context/AuthContext';
import Footer from '@/components/common/Footer';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const router = useRouter();

  // 認証済みユーザーのダッシュボードリダイレクト
  useEffect(() => {
    console.log('[Home] Component mounted');
    console.log('[Home] Auth state:', { isAuthenticated, isLoading });
    console.log('[Home] Current URL:', window.location.href);
    console.log('[Home] Cookies:', document.cookie);

    if (!isLoading && isAuthenticated) {
      console.log('[Home] Authenticated user detected, redirecting to dashboard');
      router.push('/dashboard');
    } else if (!isLoading && !isAuthenticated) {
      console.log('[Home] User not authenticated, showing login button');
    }
  }, [isAuthenticated, isLoading, router]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // 認証済みの場合は空のコンテンツを返す（リダイレクト中）
  if (isAuthenticated) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Redirecting...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="container flex-grow-1">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-md-8 col-lg-6">
            <div className="text-center mb-4">
              <h1 className="mb-4">Welcome to OPAM</h1>
              <button
                className="btn btn-primary btn-lg mb-4"
                onClick={() => {
                  console.log('[Home] Login button clicked');
                  login();
                }}
              >
                Sign in with Microsoft
              </button>
            </div>

            {/* WID339対策: 自動ログインにおける注意喚起 */}
            <div className="alert alert-warning" role="alert">
              <div className="d-flex align-items-start">
                <span className="me-2 text-warning flex-shrink-0" style={{ fontSize: '1.5rem' }}>⚠️</span>
                <div>
                  <h6 className="alert-heading mb-2">
                    🛡️ 共用端末でのご利用について
                  </h6>
                  <ul className="mb-2 small">
                    <li><strong>共用PCやタブレット</strong>では、ログイン状態が保持される可能性があります</li>
                    <li>他の利用者による<strong>不正アクセスのリスク</strong>がございます</li>
                    <li>共用環境では、<strong>必ずログアウト</strong>してからブラウザを閉じてください</li>
                  </ul>
                  <div className="small text-muted">
                    ℹ️ セキュリティ向上のため、個人用端末でのご利用を推奨いたします
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
